import type { DataChartStyleProps } from './datachartStyleRegistry'
import './TemperatureCard.css'

export type TemperatureCardVariant = 'default' | 'glass' | 'dense'

export function TemperatureCardStyle01(_props: DataChartStyleProps) {
  return <TemperatureCardBase variant="default" {..._props} />
}

export function TemperatureCardBase(_props: DataChartStyleProps & { variant?: TemperatureCardVariant }) {
  void _props
  const variant = _props.variant ?? 'default'
  const temperature = 24.6
  const humidity = 58

  return (
    <div
      className={`temperature-card temperature-card--${variant}`}
      data-css-slot="cardFrame"
      data-css-slot-label="Card Frame"
    >
      <div className="temperature-card__metrics">
        <div className="temperature-card__metric">
          <span className="temperature-card__metric-label-wrap">
            <span className="material-symbols-rounded temperature-card__metric-icon is-temperature" aria-hidden>
              thermostat
            </span>
            <span className="temperature-card__metric-label">Temperature</span>
          </span>
          <div className="temperature-card__metric-value" data-css-slot="metricValue" data-css-slot-label="Metric Value">
            {temperature.toFixed(1)}
            <small>°C</small>
          </div>
        </div>
        <div className="temperature-card__metric">
          <span className="temperature-card__metric-label-wrap">
            <span className="material-symbols-rounded temperature-card__metric-icon is-humidity" aria-hidden>
              water_drop
            </span>
            <span className="temperature-card__metric-label">Humidity</span>
          </span>
          <div className="temperature-card__metric-value" data-css-slot="metricValue" data-css-slot-label="Metric Value">
            {humidity.toFixed(0)}
            <small>%</small>
          </div>
        </div>
      </div>
    </div>
  )
}
